/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupSingleCalendarDay } from './LaundryGroupSingleCalendarDay';
import {
    LaundryGroupSingleCalendarDayFromJSON,
    LaundryGroupSingleCalendarDayFromJSONTyped,
    LaundryGroupSingleCalendarDayToJSON,
} from './LaundryGroupSingleCalendarDay';

/**
 * 
 * @export
 * @interface LaundryGroupSingleCalendar
 */
export interface LaundryGroupSingleCalendar {
    /**
     * 
     * @type {Array<LaundryGroupSingleCalendarDay>}
     * @memberof LaundryGroupSingleCalendar
     */
    days: Array<LaundryGroupSingleCalendarDay>;
}

/**
 * Check if a given object implements the LaundryGroupSingleCalendar interface.
 */
export function instanceOfLaundryGroupSingleCalendar(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "days" in value;

    return isInstance;
}

export function LaundryGroupSingleCalendarFromJSON(json: any): LaundryGroupSingleCalendar {
    return LaundryGroupSingleCalendarFromJSONTyped(json, false);
}

export function LaundryGroupSingleCalendarFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupSingleCalendar {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': ((json['days'] as Array<any>).map(LaundryGroupSingleCalendarDayFromJSON)),
    };
}

export function LaundryGroupSingleCalendarToJSON(value?: LaundryGroupSingleCalendar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': ((value.days as Array<any>).map(LaundryGroupSingleCalendarDayToJSON)),
    };
}

